module.exports = __webpack_public_path__ + "static/media/gums.fb89bc55.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svgicons/gums.svg
// module id = 96
// module chunks = 0